import React from 'react';
import PropTypes from 'prop-types';

import { themeNames } from '@embeds/core/themes';

import '@embeds/common/Root/_root.scss';

const Root = ({ device, channel, theme, thememode, children,customColor}) => (

  <div
    className="et-root"
    device={device}
    channel={channel}
    theme={theme}
    thememode={thememode}
    style={customColor ?
       (customColor.length > 0 ? {"--header-background": customColor, "--highlight-color":customColor}:{})
      : {}}
  >
    { children }
  </div>
);

Root.propTypes = {
  device: PropTypes.oneOf([ 'desktop', 'tablet', 'mobile' ]),
  channel: PropTypes.oneOf([ 'web', 'app', 'amp' ]),
  theme: PropTypes.oneOf(themeNames),
  thememode: PropTypes.oneOf([ 'light', 'dark' ]),
  customColor:PropTypes.string.isRequired
};

Root.defaultProps = {
  device: 'mobile',
  channel: 'web',
  theme: 'core',
  thememode: 'light',
};

export default Root;
